var _rect, _style, _title, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _text, _path44, _text2, _path45, _text3, _text4, _text5, _text6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem28Ch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st1{fill:#bbb}.st2{fill:#4d4d4d}.st3{fill:#e6e6e6}.st4{fill:#666}.st5{fill:#b3b3b3}.st6{fill:#ccc}.st7{fill:#393939}.st8{fill:#909090}.st9{fill:#d9d9d9}.st10{fill:#369;fill-opacity:.502}.st11{fill:#fff}.st12{font-family:'ArialMT'}.st13{font-size:11.4815px}.st14{fill:#000;font-size:12.4815px}\n  ")), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    },
    id: "svg_1"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.2 171.9l-17-35.4-17 29.3 34 6.1z",
    className: "st1",
    id: "svg_2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4 161.1l-17.2-35.4-20.1 10.8 17 35.4 20.3-10.8zM210.1 181.6l-17-35.6-20.2 11 17 35.4 20.2-10.8z",
    className: "st2",
    id: "svg_3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.8 156.6l20.1-10.9L34 108.3l-20.1 10.8 209.9 37.5z",
    className: "st3",
    id: "svg_4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M189.9 192.4l-17-35.4-17 29.3 34 6.1z",
    className: "st1",
    id: "svg_5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M243.9 157.3v-11.6l-20.1 10.9v11.5l20.1-10.8z",
    className: "st4",
    id: "svg_6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M223.8 168v-11.5L13.9 119.1v11.5L223.8 168z",
    className: "st5",
    id: "svg_7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M244.7 157.6v-12.5h-.5l-210-37.5h-.5l-20.5 11.1V131l.5.2 42.5 7.5-16.1 27.6 35.1 6.3h.2l.2-.2 20.1-10.8.5-.3-.2-.5-7.8-16.2 82.7 14.7-16.1 27.6L190 193h.2l.2-.2 20.1-10.8.5-.3-.2-.5L203 165l20.7 3.7h.2l.2-.2 20.6-10.9m-1.4-11.4v10.5l-19.4 10.6-23.1-4 8.6 17.9-19.4 10.4-33-5.9 15.8-27.4L86 142.9l8.7 18-19.4 10.3-33-5.9 15.5-26.7.5-.7-43.8-7.7v-10.7L34.3 109l209 37.2z",
    id: "svg_8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.3 105l-23.4-4.2-8.7 4.7 23.4 4.2 8.7-4.7z",
    className: "st6",
    id: "svg_9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157 132.2l-10.6-27.1-15.1 8.2 10.6 26.9 15.1-8z",
    className: "st2",
    id: "svg_10"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M131.2 113.2l-23.6-4.2L97 132.3l44.8 7.8-10.6-26.9z",
    className: "st1",
    id: "svg_11"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M137.6 109.8l-23.4-4.2-6.6 3.5 23.6 4.2 6.4-3.5z",
    className: "st6",
    id: "svg_13"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M330.3 163l-17-35.4-17 29.3 34 6.1z",
    className: "st1",
    id: "svg_14"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M350.6 152.3l-17-35.4-20.1 10.8 17 35.4 20.1-10.8zM465.3 172.7l-17-35.6-20.1 10.9 17 35.4 20.1-10.7z",
    className: "st2",
    id: "svg_15"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M479.1 152.7l20.1-10.8-209.9-37.5-20.1 10.8 209.9 37.5z",
    className: "st3",
    id: "svg_16"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M445.1 183.6l-17-35.4-17 29.3 34 6.1z",
    className: "st1",
    id: "svg_17"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M499.3 146.5V142l-20.1 10.8v4.7l20.1-11z",
    className: "st4",
    id: "svg_18"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M479.1 157.3v-4.7l-209.9-37.5v4.7l209.9 37.5z",
    className: "st5",
    id: "svg_19"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M500 146.8v-5.4l-.5-.2-209.9-37.5h-.2l-.2.2-20.7 10.9v5.6h.5l43.1 7.8-16.5 28.5-.3.9 34.9 6.3h.2l20.5-10.9.5-.3-.2-.5-9-18.5 84.7 15.2-16.5 28.5-.3.9 34.9 6.3h.2l20.5-10.9.5-.3-.3-.5-8.9-18.5 22.1 3.9h.5l20.1-10.8.3-.7m-1.2-4.5v3.7L479 156.6l-24.3-4.3.7 1 9.1 19-19.4 10.5-33-5.9 16.5-28.5.3-.9-89.1-15.8.7 1 9.1 19.1-19.4 10.4-33-5.9 16.5-28.5.3-.9-44.3-7.9v-3.6l19.4-10.6 209.7 37.5z",
    id: "svg_20"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M401.7 101.1l-23.6-4.2-8.5 4.7 23.4 4.2 8.7-4.7z",
    className: "st6",
    id: "svg_21"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M377.8 102c.1-1.9.8-3.3 2.3-4.2l-1.6.9c-1.4.8-2.2 2.2-2.3 4.2l1.6-.9z",
    className: "st7",
    id: "svg_22"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M381.2 93.9c-.4-.1-.8-.1-1.2-.1-4.6.3-7.1 3-7.5 8.2l3.8.7c.2-2.8 1.6-4.4 4.1-4.6.2 0 .5 0 .8.1 3.1.9 4.7 3 5 6.3l3.8.7c-.5-6-3.4-9.8-8.8-11.3z",
    className: "st8",
    id: "svg_23"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M412.1 128.1L401.5 101l-15.1 8.2 10.6 26.9 15.1-8z",
    className: "st2",
    id: "svg_24"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M386.5 109.3l-23.6-4.2-10.6 23.3 44.8 7.8-10.6-26.9z",
    className: "st1",
    id: "svg_25"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M392.9 105.8l-23.4-4.2-6.6 3.5 23.6 4.2 6.4-3.5z",
    className: "st6",
    id: "svg_27"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M739.6 133.2v-4.5l-40.5 21.5v4.7l40.5-21.7z",
    className: "st4",
    id: "svg_28"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M560.5 155.2l-17-35.4-17 29.3 34 6.1z",
    className: "st1",
    id: "svg_29"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M580.8 144.5l-17.2-35.4-20.1 10.8 17 35.4 20.3-10.8z",
    className: "st2",
    id: "svg_30"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M675.3 175.7l-17-35.4-17 29.3 34 6.1z",
    className: "st1",
    id: "svg_31"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M695.5 164.8l-17-35.6-20.1 10.9 17 35.4 20.1-10.7z",
    className: "st2",
    id: "svg_32"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M699.2 150.2l40.5-21.5-209.9-37.5-40.5 21.5 209.9 37.5z",
    className: "st3",
    id: "svg_33"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M699.2 154.9v-4.7l-209.9-37.5v4.7l209.9 37.5z",
    className: "st5",
    id: "svg_34"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M740.4 133.5v-5.4l-.5-.2-210.1-37.5h-.2l-.2.2-40.4 21.6-.2.2v5.6l.5.2 49.4 8.7-13.3 22.9 35.1 6.3h.2l.2-.2L581 145l.5-.3-.2-.5-5.1-10.5 77.3 13.6-13.3 22.9 34.9 6.3h.3l.2-.2 20.1-10.8.5-.3-.2-.5-5-10.7 8.2 1.4.2.2.2-.2 40.8-21.9m-1.4-4.4v3.7l-39.8 21.3-10.3-1.8 5.8 12.3-19.4 10.4-33-5.9L655 147l.5-.7-81.4-14.6 5.9 12.4-19.4 10.3-33-5.9 13.2-22.7-50.7-9.1v-3.6l40-21.4L739 129.1z",
    id: "svg_35"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M631.7 93.2L608.3 89l-8.7 4.7 23.4 4.2 8.7-4.7z",
    className: "st6",
    id: "svg_36"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M642.3 120.2l-10.6-27.1-15.1 8.2 10.6 26.9 15.1-8z",
    className: "st2",
    id: "svg_37"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M616.6 101.3L593 97.1l-10.6 23.3 44.8 7.8-10.6-26.9z",
    className: "st1",
    id: "svg_38"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M623.1 97.9l-23.4-4.2-6.6 3.5 23.6 4.2 6.4-3.5z",
    className: "st6",
    id: "svg_40"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M382.5 93c-.5-.1-.9-.1-1.3-.1-2 .1-3.7.7-4.9 1.8 1.1-.6 2.3-1 3.7-1 .3 0 .7 0 1.1.1 5.4 1.5 8.3 5.3 8.9 11.3l1.2-1c-.6-5.8-3.5-9.5-8.7-11.1z",
    className: "st9",
    id: "svg_41"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M607.8 94.1c.1-1.9.8-3.3 2.3-4.2l-1.6.9c-1.3.8-2.1 2.2-2.3 4.2l1.6-.9z",
    className: "st7",
    id: "svg_42"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M611.4 90.3c3 .9 4.6 3 4.9 6.3l3.8.7c-.6-6-3.5-9.8-8.7-11.3-.4-.1-.8-.1-1.2-.1-4.7.3-7.2 3-7.6 8.2l3.8.7c.2-2.8 1.6-4.4 4.2-4.6.2 0 .5 0 .8.1z",
    className: "st8",
    id: "svg_43"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M612.5 85.2c-.4-.1-.8-.1-1.2-.1-2 .1-3.7.7-5 1.8 1.1-.6 2.3-1 3.7-1 .5 0 .9 0 1.3.1 5.3 1.5 8.2 5.3 8.7 11.3l1.2-1c-.5-5.8-3.4-9.6-8.7-11.1z",
    className: "st9",
    id: "svg_44"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M122.6 105.9c.1-1.9.8-3.3 2.3-4.2l-1.6.9c-1.4.8-2.1 2.2-2.3 4.2l1.6-.9z",
    className: "st7",
    id: "svg_45"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M126 102.2c3 .9 4.6 3 4.9 6.3l3.8.7c-.6-6-3.5-9.8-8.7-11.3-.4-.1-.8-.1-1.2-.1-4.7.3-7.2 3-7.6 8.2l3.8.7c.2-2.8 1.6-4.4 4.2-4.6.2 0 .5.1.8.1z",
    className: "st8",
    id: "svg_46"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M127.3 97c-.4-.1-.8-.1-1.2-.1-2 .1-3.7.7-5 1.8 1.1-.6 2.3-1 3.7-1 .5 0 .9 0 1.3.1 5.2 1.5 8.1 5.3 8.7 11.3l1.2-1c-.5-5.8-3.4-9.6-8.7-11.1z",
    className: "st9",
    id: "svg_47"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M147 104.9l-.2-.3h-.3l-11.5-2.2c-1.7-3.2-4.3-5.1-7.6-5.8-.5-.2-1-.2-1.6-.2-2.1.1-3.8.7-5.2 1.9-1.9 1-3.1 2.7-3.7 4.9l-9.5 5.1-.3.3-10.9 24 45.5 8.2h.5l15.1-8.2.5-.3-10.8-27.4m-12.5-1.3l11.5 2 10.2 26.1-14.6 7.7-43.6-7.6 10.2-22.4 9.8-5.2v-.3c.6-2 1.7-3.5 3.3-4.5h.2c1.1-1.1 2.5-1.7 4.3-1.7.4 0 .8.1 1.2.2 3.1.6 5.4 2.5 6.9 5.6l.2.2.4-.1zM632.4 93.1l-.2-.3h-.3l-11.5-2.2c-1.7-3.2-4.3-5.1-7.6-5.8-.5-.2-1-.2-1.6-.2-2.1.1-3.8.7-5.2 1.9-1.9 1-3.1 2.7-3.7 4.9l-9.5 5.1-.3.3-10.9 24L627 129h.5l15.1-8.2.5-.3-10.7-27.4m-12.5-1.3l11.5 2 10.2 26.1-14.6 7.7-43.6-7.7 10.2-22.4 9.8-5.2V92c.6-2 1.7-3.5 3.3-4.5h.2c1.1-1.1 2.5-1.7 4.3-1.7.4 0 .8.1 1.2.2 3.1.6 5.4 2.5 6.9 5.6l.2.2h.4zM402.1 101v-.3h-.3l-11.5-2.2c-1.8-3.2-4.4-5.1-7.8-5.8-.5-.2-1-.2-1.6-.2-2 .1-3.7.7-5.2 1.9l.1.1c-1.8 1-3 2.7-3.6 4.9l-9.6 5.1-.2.2v.2l-10.9 24 45.5 8.2h.3l15.3-8.2.3-.3-10.8-27.6m-12.3-1.3l11.3 2 10.2 26.2-14.5 7.6-43.7-7.8 10.1-22.1 10.1-5.4v-.3c.6-2 1.7-3.5 3.3-4.5 1.3-1.1 2.7-1.7 4.3-1.7.5 0 .9.1 1.4.2 3.1.6 5.4 2.5 6.9 5.6l.2.2h.4z",
    id: "svg_48"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M131.1 201.7c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7 5.3 3.6 8.7 3.6c3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st10",
    id: "svg_49"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st11 st12 st13",
    transform: "matrix(0.9981,0,0,1,118.5674,215.3179) ",
    id: "svg_50"
  }, "\n    1\n  ")), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M377.1 201.7c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7 5.3 3.6 8.7 3.6c3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7s-1.2-6.3-3.6-8.7z",
    className: "st10",
    id: "svg_51"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st11 st12 st13",
    transform: "matrix(0.9981,0,0,1,364.6172,215.3179) ",
    id: "svg_52"
  }, "\n    2\n  ")), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M627.1 201.7c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st10",
    id: "svg_53"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "st11 st12 st13",
    transform: "matrix(0.9981,0,0,1,614.6172,215.3179) ",
    id: "svg_54"
  }, "3")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "st12 st14",
    transform: "matrix(0.9981,0,0,1,105.6172,127.3179) ",
    id: "svg_54"
  }, "5\u516C\u65A4")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "st12 st14",
    transform: "matrix(0.9981,0,0,1,359.6172,122.3179) ",
    id: "svg_55"
  }, "5\u516C\u65A4")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "st12 st14",
    transform: "matrix(0.9981,0,0,1,588.6172,115.3179) ",
    id: "svg_56"
  }, "5\u516C\u65A4"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem28Ch);
export default __webpack_public_path__ + "static/media/item28ch.5c3ef97b037f6920a1f361612a6ffcd0.svg";
export { ForwardRef as ReactComponent };